import { Controller } from "@hotwired/stimulus";

// The "Ce qui prenait des jours prend maintenant des secondes" tabs on a Solutions landing page:
// one tab per capacité, plus the dots under the screen. Server-rendered panels (always visible
// without JS — the first one just stays showing); this controller only switches which one is
// visible. A tab owns two panels, its text above the pills and its screen below, both carrying
// its index.
export default class extends Controller {
  static targets = ["tab", "panel", "dot"];

  connect() {
    this.show(0);
  }

  select(event) {
    this.show(Number(event.currentTarget.dataset.index));
  }

  show(index) {
    this.currentIndex = index;

    this.tabTargets.forEach((tab, i) => {
      tab.toggleAttribute("data-active", i === index);
    });

    this.dotTargets.forEach((dot, i) => {
      dot.toggleAttribute("data-active", i === index);
    });

    this.panelTargets.forEach((panel) => {
      panel.classList.toggle("hidden", Number(panel.dataset.index) !== index);
    });
  }
}
